<form snDrawer (ngSubmit)="submitForm()">
  <sn-drawer-header [title]="isNew ? ('cameras.newCamera' | t) : ('cameras.editCamera' | t)">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    <sn-drawer-header-actions>
      <sn-flat-button
        type="submit"
        color="success"
        [disabled]="form.invalid"
        [isLoading]="isLoading"
        >{{ 'common.save' | t }}</sn-flat-button
      >
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-alert type="danger" class="camera-form-rounded-0 camera-form-mb-0 camera-form-px-sm camera-form-py-xs" *ngIf="form.errors">
    <div *ngFor="let error of form.errors | keyvalue">
      <b>{{ error.key }}</b
      >: {{ error.value }}
    </div>
  </sn-alert>

  <sn-drawer-content>
    <mat-tab-group class="h-100" (selectedTabChange)="onTabChange($event)">
      <ng-container *ngFor="let tab of formSteps; trackBy: trackStep; let index = index">
        <mat-tab *ngIf="!tab.hideExpression || !tab.hideExpression()" [label]="tab.label">
          <sn-form [form]="form.at(index)" [fields]="tab.fields" [(model)]="formModel"></sn-form>
          <button
            mat-button
            class="regionOfInterestButton"
            type="button"
            *ngIf="tab.label === 'Detections'"
            [disabled]="!formModel.aiDetectionTypes[0]?.id"
            (click)="openAiGridDialog()"
          >
            {{ 'cameras.defineRegionOfInterest' | t }}
          </button>
          <button
            mat-button
            class="scheduleButton"
            type="button"
            *ngIf="tab.label === 'Detections'"
            [disabled]="!formModel.aiDetectionTypes[0]?.id"
            (click)="openAiSchedulerDialog()"
          >
            {{ 'cameras.defineSchedule' | t }}
          </button>
          <button
            mat-button
            class="newRuleButton"
            type="button"
            *ngIf="
              tab.label === 'Detections' &&
              (currentOrganization.settings.isDemo || selectedAppliance?.settings?.allowManageRules)
            "
            [disabled]="!formModel.aiDetectionTypes[0]?.id"
            (click)="openAiRulesDialog()"
          >
            {{ 'cameras.manageRules' | t }}
          </button>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </sn-drawer-content>
</form>
